import React from "react";
import { Button } from "@/components/ui/button";
import { Minus, Plus, Ticket } from "lucide-react";

const inr = (n) => `₹${Math.round(n || 0).toLocaleString("en-IN")}`;

export function ActivityPicker({ activities, selected, setSelected, testPrefix = "activity" }) {
  if (!activities || activities.length === 0) return null;
  const maxFor = (a) => Math.min(Number(a.max_per_person || 1), a.remaining == null ? 99 : a.remaining);
  const setQty = (a, q) => {
    const qty = Math.max(0, Math.min(q, maxFor(a)));
    setSelected((s) => ({ ...s, [a.id]: qty }));
  };
  return (
    <div className="space-y-2.5">
      {activities.map((a) => {
        const qty = selected[a.id] || 0;
        const soldOut = a.sold_out || a.remaining === 0;
        return (
          <div key={a.id} data-testid={`${testPrefix}-${a.id}`} className={`rounded-xl border p-3.5 ${soldOut ? "border-border opacity-60" : "border-border"}`}>
            <div className="flex items-center justify-between gap-3">
              <div>
                <div className="flex items-center gap-2">
                  <Ticket className="h-4 w-4 text-[#FF4500]" />
                  <span className="font-semibold text-white">{a.name}</span>
                  <span className="text-[#FF7043] font-semibold">{inr(a.price)}</span>
                </div>
                <div className="mt-1 text-xs text-[#A1A1AA]">
                  {soldOut ? (
                    <span className="text-[#FF6B6B] font-semibold">Sold Out</span>
                  ) : (
                    <>
                      {a.remaining != null && <span>Available: {a.remaining} · </span>}
                      <span>Max per person: {a.max_per_person}</span>
                    </>
                  )}
                </div>
              </div>
              {soldOut ? (
                <span className="text-xs font-bold uppercase text-[#FF6B6B] bg-[#FF6B6B]/10 rounded-full px-3 py-1">Sold Out</span>
              ) : (
                <div className="flex items-center gap-2 shrink-0">
                  <Button type="button" data-testid={`${testPrefix}-${a.id}-minus`} onClick={() => setQty(a, qty - 1)} disabled={qty <= 0} variant="outline" size="icon" className="rounded-full border-border h-8 w-8"><Minus className="h-3.5 w-3.5" /></Button>
                  <span data-testid={`${testPrefix}-${a.id}-qty`} className="font-display text-lg font-800 w-6 text-center">{qty}</span>
                  <Button type="button" data-testid={`${testPrefix}-${a.id}-plus`} onClick={() => setQty(a, qty + 1)} disabled={qty >= maxFor(a)} variant="outline" size="icon" className="rounded-full border-border h-8 w-8"><Plus className="h-3.5 w-3.5" /></Button>
                </div>
              )}
            </div>
            {qty > 0 && <div className="mt-2 text-right text-xs text-[#A1A1AA]">{qty} × {inr(a.price)} = <span className="text-white font-semibold">{inr(qty * a.price)}</span></div>}
          </div>
        );
      })}
    </div>
  );
}

export const activitiesPayload = (activities, selected) =>
  (activities || []).filter((a) => (selected[a.id] || 0) > 0).map((a) => ({ id: a.id, qty: selected[a.id] }));

export const activitiesTotal = (activities, selected) =>
  (activities || []).reduce((s, a) => s + (selected[a.id] || 0) * Number(a.price || 0), 0);
